import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

import {
    IBookInviteActionResult,
}                               from '../interfaces';

const cancelBookInvite = async ({
    test,
    assignmentId,
}: {
    test: boolean,
    assignmentId: string,
}): Promise<IBookInviteActionResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        {
            test: boolean,
            assignmentId: string,
        },
        IBookInviteActionResult
    >(
        functions,
        'cancelBookInvite',
    );
    return callable({
        test,
        assignmentId,
    }).then((result) => result.data as IBookInviteActionResult);
};

export default cancelBookInvite;
